import { Site } from '../../../types';

// Winter Condition shows only from 1st Nov to 30th April
const isInWinterWindow = (d: Date = new Date()): boolean => {
  if (isWinterConditionSummerDisplay) return true;
  const m = d.getMonth();
  return m >= 10 || m <= 3; // Nov–Apr
};

type WinterConditions = {
  winterElection: string | null;
  winterElectionNotes: string | null;
  isShowWinterConditions: boolean;
};

export const useWinterConditions = (site: Site): WinterConditions => {
  const rawElection = site?.projectInfo?.winterElection;
  const rawNotes = site?.projectInfo?.winterElectionNotes;

  const winterElection = rawElection?.trim() || null;
  const winterElectionNotes = rawNotes?.trim() || null;

  const isShowWinterConditions = !!winterElection && winterElection !== 'Always scan' && isInWinterWindow();

  return { winterElection, winterElectionNotes, isShowWinterConditions };
};
